import { render, staticRenderFns } from "./TabsAdvSelector.vue?vue&type=template&id=57ad9b70&scoped=true"
import script from "./TabsAdvSelector.vue?vue&type=script&lang=js"
export * from "./TabsAdvSelector.vue?vue&type=script&lang=js"
import style0 from "./TabsAdvSelector.vue?vue&type=style&index=0&id=57ad9b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad9b70",
  null
  
)

export default component.exports